import { render, staticRenderFns } from "./RepairsList.vue?vue&type=template&id=7244ab0c&scoped=true&"
import script from "./RepairsList.vue?vue&type=script&lang=js&"
export * from "./RepairsList.vue?vue&type=script&lang=js&"
import style0 from "./RepairsList.vue?vue&type=style&index=0&id=7244ab0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7244ab0c",
  null
  
)

export default component.exports